import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from '@neworg-net/amsuite-core/config';
import { Observable, of } from 'rxjs';

import { httpOptions } from '../constants/http-options.constant';
import { requireHostUrl } from '../shared/required-host-url';
import { AppService } from './app.service';
import type { NotificationAction } from './notifications';

/**
 * Verifica il dettaglio con le stesse API delle app destinatarie. Il contesto è quello
 * business ordinario, dopo l'eventuale cambio azienda, mai quello globale dell'inbox.
 */
@Injectable({ providedIn: 'root' })
export class NotificationContentService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(ConfigService);
  private readonly appService = inject(AppService);

  getTarget(action: NotificationAction): Observable<unknown> {
    switch (action.kind) {
      case 'dialog':
        return this.http.get(
          `${requireHostUrl(this.config, 'dialog').replace(/\/$/, '')}/dialog/v1/requests/${encodeURIComponent(action.requestId)}`,
        );
      case 'activity':
      case 'project':
        // Calendar legge ancora questi dettagli dal gateway legacy.
        return this.http.get(
          `${this.appService.getServerBaseUrl}/${action.kind}/${encodeURIComponent(action.objectId)}`,
          httpOptions,
        );
      case 'news':
        return this.http.get(
          `${requireHostUrl(this.config, 'amcomunica').replace(/\/$/, '')}/news/${encodeURIComponent(action.newsId)}`,
        );
      case 'application':
        return of(true);
    }
  }
}
